<template>
  <div class="right-top-chart">
    <!-- right top chart title  -->
    <h6 class="chart-title">
      {{ $t('dashboard.titles.investIdeas') }} {{ ' ' }}
      <span class="title-question-icon" @click.prevent="toggleHelp()">
        <iquestion />
      </span>
      <span
        class="settings-tab-text-icon multi-collapse collapse"
        :class="{ show: $store.state.layout.settingsOpened }"
        id="setting-overlay"
        style=""
      >
        <i class="fa fa-eye"></i>
      </span>
    </h6>
    <div class="settings-tab">
      <div
        class="right-top-chart-table max Custom_Scrollbar"
        :class="{ 'no-content': noContent }"
      >
        <p v-if="noContent">{{ $t('dashboard.investIdeas.noContent') }}</p>
        <table class="table-cover" v-else>
          <tbody>
            <tr class="table-header-sort-title">
              <th class="single-sort-title">
                <div class="col-title"></div>
              </th>
              <th class="single-sort-title">
                <div class="col-title">
                  {{ $t('dashboard.investIdeas.analyst') }}

                  <span class="sort" v-if="false">
                    <svg
                      class="sort__up ascending"
                      width="8"
                      height="4"
                      viewBox="0 0 8 4"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M4 0L0 4H8L4 0Z" fill="#C2C2D6"></path>
                    </svg>
                    <svg
                      class="sort__down"
                      width="8"
                      height="4"
                      viewBox="0 0 8 4"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M4 4L0 0H8L4 4Z" fill="#C2C2D6"></path>
                    </svg>
                  </span>
                </div>
              </th>
              <th class="single-sort-title">
                <div class="col-title">
                  {{ $t('dashboard.investIdeas.direction') }}
                </div>
              </th>
              <th class="single-sort-title">
                <div class="col-title">
                  {{ $t('dashboard.investIdeas.target') }}
                </div>
              </th>
              <th class="single-sort-title">
                <div class="col-title">
                  {{ $t('dashboard.investIdeas.currentProfit') }}
                </div>
              </th>
              <th class="single-sort-title">
                <div class="col-title">
                  {{ $t('dashboard.investIdeas.duration') }}
                </div>
              </th>
            </tr>
            <tr
              class="single-content-items pointer"
              v-for="(idea, i) in sortedIdeas"
              :key="i"
              @click="onClick(idea)"
            >
              <td>{{ idea.date }}</td>
              <td class="custom-size">
                {{
                  typeof idea.analyst === 'object'
                    ? idea.analyst[$i18n.locale]
                    : idea.analyst
                }}
              </td>
              <td class="custom-size">
                {{
                  idea.direction === 'up'
                    ? $t('dashboard.investIdeas.long')
                    : $t('dashboard.investIdeas.short')
                }}
              </td>
              <td class="custom-size">{{ financial(idea.target) }}</td>
              <td
                class="colored"
                :class="{
                  'text-red': profit(idea.open, idea.direction === 'up') < 0,
                }"
              >
                {{ profit(idea.open, idea.direction === 'up') | percent }}
              </td>
              <td style="white-space: nowrap;">
                {{ idea.duration }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="settings-tab-overlay multi-collapse collapse"
        :class="{ show: $store.state.layout.settingsOpened }"
        id="setting-overlay"
        style=""
      ></div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'
import moment from 'moment'
import iquestion from '@/components/icons/question'

export default {
  computed: {
    noContent() {
      return this.sortedIdeas.length === 0
    },
    ...mapState('ticker', {
      sortedIdeas(state) {
        return state.ideas
          .map((el) => ({
            date: moment(el.datePublished),
            analyst: { ru: el.analystName_ru, en: el.analystName_en },
            direction: el.target > el.openedPrice ? 'up' : 'down',
            target: el.target,
            open: el.openedPrice,
            duration: this.$store.getters['ideas/getIdeaPeriodAndTimeLeft']({
              openDate: new Date(el.openDate),
              targetDate: new Date(el.targetDate),
            }),
            rating: el.analystRating,
            source: el.source,
          }))
          .sort((a, b) => {
            return moment(b.date) - moment(a.date)
          })
          .map((el) => ({
            ...el,
            date: el.date.format('DD.MM.YYYY'),
          }))
      },
    }),
  },
  methods: {
    toggleHelp() {
      this.$store.commit('layout/updateModal', {
        modal: 'help',
        show: true,
        title: this.$t('modals.references.investIdeas.title'),
        content: this.$t('modals.references.investIdeas.content'),
        subtitle: this.$t('modals.messages.reference'),
      })
    },
    profit(open, isLong = true) {
      return (
        (isLong ? 1 : -1) *
        (this.$store.state.market.currentPrice / open - 1) *
        100
      )
    },
    onClick(idea) {
      if (idea.source) {
        window.open(idea.source, '_blank')
      }
    },
    financial(value) {
      if (_.isUndefined(value)) return ''
      return _.isNumber(value)
        ? value.toFixed(this.$store.state.market.digitsAfterDot)
        : '-'
    },
  },
  filters: {
    percent(value) {
      if (_.isUndefined(value)) return ''
      return `${value > 0 ? '+' : ''}${value.toFixed(2)}%`
    },
  },
  components: {
    iquestion: iquestion,
  },
}
</script>

<style lang="scss">
.chart-area-wrap {
  .left-chart-top-wrap,
  .right-top-chart,
  .right-mid-chart-left {
    margin-bottom: 1.5rem;
  }

  .right-top-chart {
    max-height: 160px;
    overflow: hidden;
  }

  .right-top-chart-table {
    overflow-x: auto;
    overflow-y: auto; //scroll
    height: 120px;

    .table-cover {
      width: 100%;

      .table-header-sort-title {
        .single-sort-title {
          .col-title {
            font-size: 0.75rem;
            font-weight: 700;
            white-space: nowrap;
            padding: 0px;

            .sort {
              position: relative;
              display: inline-block;
              width: 10px;

              &__up {
                cursor: pointer;
                position: absolute;
                top: -9px;
                left: 0;

                &.ascending path {
                  stroke: #000;
                  fill: #000;
                }
              }
              &__down {
                cursor: pointer;
                position: absolute;
                top: -3px;
                left: 0;
              }
            }
          }
        }
      }

      .single-content-items {
        border-radius: 4px;
        // @include transition();

        // &:hover {
        //   background: rgba(#00a6cb, 0.2);
        // }

        &.pointer {
          @include transition();
          &:hover {
            cursor: pointer;
            background: rgba(#00a6cb, 0.2);
          }
        }

        td {
          font-size: 0.75rem;

          &.custom-size {
            font-size: 1rem;
            color: #000000;
            white-space: nowrap;

            @media (max-width: 1200px) {
              padding: 0px 5px;
            }
            span {
              color: #8a8a8a;
            }
          }

          &.colored {
            font-size: 1rem;
            color: $primary-color;
          }

          .rating-bars {
            min-width: 60px;

            span {
              width: 12px;
              height: 12px;
              border-radius: 50%;
              background: #c2c2d6;
              display: inline-block;

              &.active {
                background: $primary-color;
              }
            }
          }
        }
      }
    }
  }
}
</style>
